const CircleArrowUpDoubleIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 11.0846C9 11.0846 11.2095 8.50001 12 8.5C12.7906 8.49999 15 11.0846 15 11.0846M9 15.5C9 15.5 11.2095 12.9154 12 12.9154C12.7906 12.9154 15 15.5 15 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowUpDoubleIcon as default };
//# sourceMappingURL=CircleArrowUpDoubleIcon.js.map
